module.exports = __webpack_public_path__ + "img/course-planning-header-cover.e5fa9151.svg";